const mediaItems = [
  {
    title: '《秘密恋爱》第二季预告解析',
    desc: '热门校园韩漫续作剧情前瞻，画风全面升级',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20scene%2C%20two%20students%20under%20cherry%20blossom%20tree%2C%20soft%20warm%20pink%20and%20coral%20color%20palette%2C%20digital%20illustration%20style%2C%20dreamy%20atmosphere%2C%20spring%20lighting%2C%20emotional%20K-drama%20aesthetic&width=640&height=360&seq=media-manhwa-01&orientation=landscape',
  },
  {
    title: '奇幻韩漫《剑与魔法》动画化决定',
    desc: '高人气冒险题材正式宣布动画改编，制作阵容公开',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20scene%2C%20warrior%20with%20magical%20sword%20in%20battle%20stance%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20epic%20atmosphere%2C%20digital%20art%2C%20dynamic%20composition%2C%20cinematic%20quality&width=640&height=360&seq=media-manhwa-02&orientation=landscape',
  },
  {
    title: '2026上半年韩漫销量TOP10揭晓',
    desc: '恋爱与奇幻题材包揽前五，新锐作者强势崛起',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20ranking%20chart%20visualization%2C%20colorful%20graphic%20design%20with%20comic%20book%20elements%2C%20warm%20coral%20and%20amber%20gradient%2C%20modern%20infographic%20style%2C%20clean%20composition%2C%20digital%20art&width=640&height=360&seq=media-manhwa-03&orientation=landscape',
  },
  {
    title: '悬疑韩漫《暗夜追凶》读者解析',
    desc: '剧情伏笔深度盘点，隐藏线索与结局预测全整理',
    views: '72万',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20scene%2C%20detective%20character%20in%20dark%20alley%20with%20neon%20lights%2C%20noir%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20accents%2C%20digital%20illustration%2C%20suspenseful%20mood%2C%20cinematic&width=640&height=360&seq=media-manhwa-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">韩漫视频精选</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            热门韩漫解说、预告与深度分析，不错过每一部精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`布丁漫画韩漫视频 — ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-sm"></i>
                  </div>
                  <span className="text-xs text-background-50/90">{item.views}次观看</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}